import {UICoinsController} from '../../../shared/scripts/ui_coins/UICoinsController'
import {setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'
import {UIMSceneEnum} from '../../../../shared/enums/UIMSceneEnums'
import {UIMSceneController} from '../ui_html/UIMSceneController'
import {AudioManager, AudioType} from '@colonist/audio'

export class UIMCoinsController extends UICoinsController {
    private readonly sceneController: UIMSceneController

    constructor(sceneController: UIMSceneController) {
        super()
        this.sceneController = sceneController
    }

    protected initCoinClick() {
        setElementOnClick(this.headerCoinsContainer, () => {
            AudioManager.play(AudioType.Click)
            this.sendCoinClickAnalytic()
            this.sceneController.loadScene(UIMSceneEnum.Store)
        })
    }
}
